import { isRS } from '@/utils';

export const accountTypeCodeLength = () => (isRS() ? 5 : 2);
export const expenditurePurposeCodeLength = (isMajorMatter?: boolean) =>
  isRS() ? (isMajorMatter ? 2 : 15) : 2;
export const expenditureNatureCodeLength = (isLevel2?: boolean) =>
  isLevel2 ? 4 : 2;
export const revenueNatureCodeLength = (isLevel4?: boolean) =>
  isLevel4 ? 3 : 2;

export const ACCOUNT_TITLE_CODE_LENGTH = 5;
export const EXPENDITURE_BUDGET_ORGANIZATION_CODE_LENGTH = 3;
export const COST_CODE_LENGTH = 2;
export const MINISTRY_CODE_LENGTH = 20;
export const EXPENDITURE_BUDGET_JURISDICTION_CODE_LENGTH = 2;
export const EXPENDITURE_BREAKDOWN_PURPOSES_CODE_LENGTH = 2;
export const EXPENDITURE_ITEM_NATURES_CODE_LENGTH = 2;
export const NATIONAL_EXPENDITURE_NATURE_CODE_LENGTH = 2;
export const BUDGET_TYPE_EXTERNAL_SYSTEM_KEY_MAX_LENGTH = 255;
export const EXPENDITURE_NATURE_EXTERNAL_SYSTEM_CODE_MAX_LENGTH = 12;
export const POLICY_CODE_LENGTH = 4;
